'use client';

import { AnimatePresence, motion, Variants } from 'framer-motion';
import { FC, HTMLAttributes, PropsWithChildren, useMemo } from 'react';

export interface IEntering extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  offset?: number;
  position?: 'left' | 'right' | 'top' | 'bottom';
  stiffness?: number;
  duration?: number;
  damping?: number;
  mass?: number;
  amount?: 'some' | 'all' | number;
  delay?: number;
  initial?: boolean;
}

const Entering: FC<IEntering> = ({
  offset = 50,
  position: initPosition = 'bottom',
  duration = 0.2,
  stiffness = 100,
  damping = 12,
  mass = 1,
  delay = 0.0,
  children,
  initial = true,
  className = '',
  style = {}
}) => {
  const position = useMemo(() => {
    if (initPosition === 'left') {
      return { x: -1 * offset * 2 };
    }
    if (initPosition === 'right') {
      return { x: offset };
    }
    if (initPosition === 'top') {
      return { y: -1 * offset };
    }
    if (initPosition === 'bottom') {
      return { y: offset };
    }
  }, [offset, initPosition]);

  const variants: Variants = {
    inactive: {
      opacity: 1,
      y: 0,
      x: 0
    },
    out: {
      opacity: 0
    },
    in: {
      ...position,
      opacity: 0
    }
  };

  return (
    <AnimatePresence mode="wait" initial={initial}>
      <motion.div
        variants={variants}
        initial="in"
        animate="inactive"
        exit="out"
        className={className}
        style={style}
        transition={{
          type: 'spring',
          damping,
          stiffness,
          restDelta: 0.01,
          mass,
          duration,
          delay
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default Entering;
